import React, { useEffect, useState } from 'react';
import api from '../services';
import { IMG_BASE_URL } from '../Helpers';
export default function TestimonialsCarousel() {
    const [testimonials, setTestimonials] = useState([]);

    const fetchTestimonials = async () => {
        try {
            const data = await api("GET", "testimonials");
            setTestimonials(data);
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        fetchTestimonials();
    }, []);
    return (
        <div className="py-5 bg-light-green">
            <div className="container px-5 my-5">

                <div id="testimonialCarousel" className="carousel slide" data-bs-ride="carousel">

                    <div className="carousel-inner">

                        {testimonials.map((t, index) => (
                            <div
                                className={`carousel-item ${index === 0 ? "active" : ""}`}
                                key={index}
                            >
                                <div className="text-center px-5">
                                    <div className="fs-6 mb-4 fst-italic">
                                        "{t.message}"
                                    </div>

                                    <div className="d-flex align-items-center justify-content-center">
                                        <img className="rounded-circle me-3" src={IMG_BASE_URL + "authors/" + t?.image} width={60}
                                            height={60} alt={t.name} />

                                        <div className="fw-bold">
                                            {t.name}
                                            <span className="fw-bold text-primary mx-1">/</span>
                                            {t.role}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}

                    </div>

                </div>

            </div>
        </div>
    );
}
